import { useQuery } from '@tanstack/react-query'
import { KEY_AFFILIATE_DETAILS } from '../keys'
import { TCommonParams } from '../types'
import { getAffiliateDetails } from '../resources'

export function useGetAffiliateDetailsQuery(params: TCommonParams) {
  return useQuery({
    queryKey: [KEY_AFFILIATE_DETAILS, ...Object.values(params)],
    queryFn: () => getAffiliateDetails(params),
  })
}
